import { menulyticsLogo } from '@vgrubs/components';

type Props = {
  /** Width and height in px. */
  size?: number;
};

/**
 * Menulytics' own mark (their square logo, from menulytics.ai). The reports
 * are a partnership with them, not a vGrubs AI feature, so their logo marks
 * the way in and the modal.
 */
export const MenulyticsMark = ({ size = 20 }: Props) => (
  <img
    src={menulyticsLogo}
    alt="Menulytics"
    width={size}
    height={size}
    style={{ display: 'block', borderRadius: size / 4, flex: 'none' }}
  />
);
